import React, { useState, useEffect, useRef } from "react";
import "./styles/styles.css";
import "../../styles/global.css";
import AddPerson from "./components/AddPerson";
import AddEvent from "./components/AddEvent/AddEvent";
import AddGroup from "./components/AddGroup";
import AddUser from "./components/AddUser";
import AddVehicle from "./components/AddVehicle";
import UserAdded from "./components/UserAdded";
import MessageModal from "./components/MessageModal";
import UploadError from "./components/UploadError";
import Status from "./components/Status";
import ChangeStatus from "./components/ChangeStatus";
import Profile from "./components/Profile/Profile";
import EventGroup from "./components/EventGroup";
import AddUsersToEventGroup from "./components/AddUsersToEventGroup";
import AddTemplate from "./components/AddTemplate";
import ForgotPassword from "./components/ForgotPassword";
import ImportUsers from "./components/ImportUsers";

// Build-time literal (unlike apiRoutes) so Terser can prove ImportUsers is
// dead code outside Third — genuinely absent from First/Second's compiled
// bundle. .env.first and .env.second have no importUsers route; bulk
// credential import is a Third-only (Users management) concept.
const TIER = process.env.REACT_APP_MODE;

const Modal = ({
  type,
  onCloseClick,
  object,
  editing,
  event_id,
  message,
  onClick,
  children,
  changeImage,
  newUser,
  handleAddData,
  handleUpdateData,
  handleDeleteData,
  setMessageAlert,
  data,
  editPersonLoading,
  setEditPersonLoading,
  crop,
  personId,
  personStatus,
  statusChange,
  eventId,
  dogadjajGrupaId,
  activeGroup,
  usersOnEvent,
  showEventGroupField,
  predefinedEventGroup,
  parent,
  loginUser,
  onImported,
}) => {
  console.log("statusChange", statusChange);

  const onCloseClickRef = useRef(onCloseClick);

  useEffect(() => {
    onCloseClickRef.current = onCloseClick;
  }, [onCloseClick]);

  useEffect(() => {
    document.body.style.overflow = "hidden";

    const handleEscapeKey = (event) => {
      if (event.key === "Escape") {
        onCloseClickRef.current();
      }
    };

    const handleEnterKey = (event) => {
      if (
        event.key === "Enter" &&
        !event.shiftKey &&
        !event.ctrlKey &&
        !event.metaKey
      ) {
        const target = event.target;
        if (
          target.tagName === "TEXTAREA" ||
          (target.tagName === "INPUT" &&
            target.type !== "submit" &&
            target.type !== "button")
        ) {
          return;
        }

        const modalWrapper = document.querySelector(".modal-wrapper");
        if (!modalWrapper) return;
        let primaryButton = modalWrapper.querySelector(
          ".accreditation-button.save:not(.disabled), .accreditation-button.add-confirm:not(.disabled)",
        );

        if (!primaryButton) {
          const allButtons = modalWrapper.querySelectorAll(
            ".accreditation-button:not(.disabled)",
          );
          primaryButton = Array.from(allButtons).find(
            (btn) =>
              btn.className.includes("save") ||
              btn.className.includes("add-confirm"),
          );
        }

        if (!primaryButton) {
          primaryButton = modalWrapper.querySelector(
            ".accreditation-button:not(.disabled)",
          );
        }

        if (primaryButton && !primaryButton.disabled) {
          event.preventDefault();
          primaryButton.click();
        }
      }
    };

    document.addEventListener("keydown", handleEscapeKey);
    document.addEventListener("keydown", handleEnterKey);

    return () => {
      document.body.style.overflow = "";
      document.removeEventListener("keydown", handleEscapeKey);
      document.removeEventListener("keydown", handleEnterKey);
    };
  }, []);

  console.log("Modal type:", type);

  const renderComponent = () => {
    switch (type) {
      case "event":
        return (
          <AddEvent
            onCloseClick={onCloseClick}
            object={object}
            editing={editing}
            handleAddData={handleAddData}
            handleUpdateData={handleUpdateData}
            handleDeleteData={handleDeleteData}
            setMessageAlert={setMessageAlert}
          />
        );
      case "person":
        return (
          <AddPerson
            onCloseClick={onCloseClick}
            object={object}
            editing={editing}
            event_id={event_id}
            children={children}
            changeImage={changeImage}
            handleAddData={handleAddData}
            handleUpdateData={handleUpdateData}
            handleDeleteData={handleDeleteData}
            setMessageAlert={setMessageAlert}
            editPersonLoading={editPersonLoading}
            setEditPersonLoading={setEditPersonLoading}
            crop={crop}
          />
        );
      case "group":
        return (
          <AddGroup
            onCloseClick={onCloseClick}
            object={object}
            editing={editing}
            handleAddData={handleAddData}
            handleUpdateData={handleUpdateData}
            handleDeleteData={handleDeleteData}
            setMessageAlert={setMessageAlert}
          />
        );
      case "user":
        return (
          <AddUser
            onCloseClick={onCloseClick}
            object={object}
            editing={editing}
            handleAddData={handleAddData}
            handleUpdateData={handleUpdateData}
            handleDeleteData={handleDeleteData}
            setMessageAlert={setMessageAlert}
            predefinedEventGroup={predefinedEventGroup}
            showEventGroupField={showEventGroupField}
            eventId={eventId}
            loginUser={loginUser}
          />
        );
      case "vehicle":
        return (
          <AddVehicle
            onCloseClick={onCloseClick}
            object={object}
            editing={editing}
            eventId={eventId}
            dogadjajGrupaId={dogadjajGrupaId}
            handleAddData={handleAddData}
            handleUpdateData={handleUpdateData}
          />
        );

      case "user-added":
        return <UserAdded newUser={newUser} onCloseClick={onCloseClick} />;
      case "event-group":
        return (
          <EventGroup
            onCloseClick={onCloseClick}
            object={object}
            editing={editing}
            eventId={eventId}
            handleAddData={handleAddData}
            handleUpdateData={handleUpdateData}
            handleDeleteData={handleDeleteData}
            parent={parent}
          />
        );
      case "status":
        return (
          <Status
            onCloseClick={onCloseClick}
            personId={personId}
            personStatus={personStatus}
            handleUpdateData={handleUpdateData}
            statusChange={statusChange}
          />
        );
      case "forgot-password":
        return <ForgotPassword onCloseClick={onCloseClick} />;
      case "import-users":
        return TIER === "third" ? (
          <ImportUsers onCloseClick={onCloseClick} onImported={onImported} />
        ) : null;
      case "change-status":
        return (
          <ChangeStatus
            onCloseClick={onCloseClick}
            personId={personId}
            personStatus={personStatus}
            handleUpdateData={handleUpdateData}
            statusChange={statusChange}
            setMessageAlert={setMessageAlert}
          />
        );
      case "upload-error":
        return <UploadError data={data} onCloseClick={onCloseClick} />;
      case "profile":
        return <Profile onCloseClick={onCloseClick} />;
      case "template":
        return (
          <AddTemplate
            onCloseClick={onCloseClick}
            object={object}
            editing={editing}
            handleAddData={handleAddData}
            handleUpdateData={handleUpdateData}
            handleDeleteData={handleDeleteData}
          />
        );
      case "message":
        return (
          <MessageModal
            message={message}
            onCloseClick={onCloseClick}
            onClick={onClick}
          />
        );
      case "users-to-event-group":
        return (
          <AddUsersToEventGroup
            onCloseClick={onCloseClick}
            eventId={eventId}
            activeGroup={activeGroup}
            usersOnEvent={usersOnEvent}
            handleUpdateData={handleUpdateData}
          />
        );
      default:
        return null;
    }
  };

  const handleOverlayClick = (e) => {
    // Only close if clicking directly on the overlay, not on modal content
    if (e.target === e.currentTarget) {
      onCloseClick();
    }
  };

  // The 4 EditModalShell-based modals pin their own header to the viewport
  // top and reserve space for it via padding — vertically centering the
  // wrapper on top of that leaves a gap between header and body whenever
  // content is shorter than the viewport, so they anchor to the top instead.
  const usesEditModalShell = [
    "person",
    "group",
    "user",
    "vehicle",
    "event-group",
    "event",
    "template",
  ].includes(type);

  return (
    <div
      className={`flex-direction-row justify-center width-100 modal-wrapper ${
        usesEditModalShell ? "items-start" : "items-center"
      }`}
      onClick={handleOverlayClick}
    >
      {renderComponent()}
    </div>
  );
};

export default Modal;
